const angular = require('angular');

const OrderManagementService = require('./ordermanagement.service');


angular.module('wowApp.shop')
    .service(
        'OrderManagementService',
        ['$timeout', '$rootScope', 'Restangular', 'RestangularV3', 'BreakpointsService', 'TrolleyService', OrderManagementService],
    );



// WEBPACK FOOTER //
// ./src/order/ordermanagement/index.js